#import "../../../../activity-ai/graphql/fragments/zoom-meeting-timeline-fragment.graphql"

fragment ActivityFragmentSparse on Activity {
    id
    name
    isMediaLogged
    activityType {
        id
        name
        icon
    }
    logNote {
        id
        bodyHtml
    }
    participants {
        id
        name
        avatarUrl
        initials
        htmlUrl
    }
    externalMeeting {
        ...ZoomMeetingTimelineFragment
    }
    transcription
}
